import { useI18n } from '@affine/i18n';
import { type ReactNode, useCallback } from 'react';

import dotBgLight from './assets/dot-bg.light.png';
import containerBg from './assets/container-bg.png';
import { DesktopNavbar } from './desktop-navbar';
import * as styles from './index.css';
import { MobileNavbar } from './mobile-navbar';

export const AffineOtherPageLayout = ({
  children,
}: {
  children: ReactNode;
}) => {
  const t = useI18n();

  const openDownloadLink = useCallback(() => {
    open(BUILD_CONFIG.downloadUrl, '_blank');
  }, []);

  //关闭:APP下载提示框
  return (
    <div
      className={styles.root}
      style={{ backgroundImage: `url(${dotBgLight})` }}
    >
      <img src={containerBg} style={{ position: 'absolute', width: '100%', height: '100%', zIndex: '-1', opacity: '.6' }} alt="" />
      {BUILD_CONFIG.isElectron ? (
        <div className={styles.draggableHeader} />
      ) : (
        <div className={styles.topNav}>
          <a href="/" rel="noreferrer" className={styles.affineLogo}>
            {/* <Logo1Icon width={24} height={24} /> */}
          </a>

          <DesktopNavbar />
          {/* <Button
            onClick={openDownloadLink}
            className={styles.hideInSmallScreen}
          >
            {t['com.affine.auth.open.affine.download-app']()}
          </Button> */}
          <MobileNavbar />
        </div>
      )}

      {children}
    </div>
  );
};
